export * from './iconFontAwesomeMovingRoute';
export * from './iconFontAwesomeMovingWineGlass';
export * from './iconFontAwesomeMovingTruckRampBox';
export * from './iconFontAwesomeMovingTruckMoving';
export * from './iconFontAwesomeMovingTrailer';
export * from './iconFontAwesomeMovingTape';
export * from './iconFontAwesomeMovingSuitcase';
export * from './iconFontAwesomeMovingSignHanging';
export * from './iconFontAwesomeMovingPeopleCarryBox';
export * from './iconFontAwesomeMovingHouseChimney';
export * from './iconFontAwesomeMovingDolly';
export * from './iconFontAwesomeMovingCouch';
export * from './iconFontAwesomeMovingCaravan';
export * from './iconFontAwesomeMovingBoxesPacking';
export * from './iconFontAwesomeMovingBoxOpen';
export * from './iconFontAwesomeMovingBoxArchive';
